export default __webpack_public_path__ + "static/v2_anca_bw-94306c5d36d7eea3e3b49b8620951bd8.jpg";